/**
 * socket 连接、接收/发送消息
 */

import groupMessage from '@/utils/message_layout'
import chatSendMixin from './chat_send'
import chatReceiveMixin from './chat_receive'
import {
    EVALUATE_MESSAGE,
    SET_MESSAGE_VALUE_BY_ID,
    REMOVE_MESSAGE,
    WITHDRAW_MESSAGE
} from '@/constants/pub_sub'

export default {
    mixins: [ chatSendMixin, chatReceiveMixin ],
    data () {
        return {
            messageList: [],
            noreadmsgid: new Set([])
        }
    },
    watch: {
        // 未 deep，主要监听长度变化（含replace）
        messageList (messageList) {
            // S 消息分组
            const groupList = groupMessage(messageList)
            groupList.forEach(group => {
                const [
                    groupStartIndex,
                    groupEndIndex,
                    groupAvatarIndex
                ] = group

                for (let i = groupStartIndex; i <= groupEndIndex; i++) {
                    let layout = {
                        isGroupStart: false,
                        isGroupEnd: false,
                        isShowHost: false
                    }
                    if (i === groupStartIndex) {
                        layout.isGroupStart = true
                    }
                    if (i === groupEndIndex) {
                        layout.isGroupEnd = true
                    }
                    if (i === groupAvatarIndex) {
                        layout.isShowHost = true
                    }
                    this.setMessageValueByIndex(i, 'layout', layout)
                }
            })
            // E 消息分组

            this.setTheLastEventQueueId(messageList)

            // 若 page 可见，则设置已读
            this.visibilitychangeHandle()
        }
    },
    methods: {
        async reset () {
            this.$toast.loading({
                duration: 0,
                message: '正在重连...',
                forbidClick: true,
                loadingType: 'circular'
            })

            try {
                this.messageList = []
                await this.resetHistory()
            } finally {
                this.$toast.clear()
            }
        },

        /**
         * 通过 EventBus 暴露部分 chat_utils 和操作 messageList 方法供后代组件使用
         */
        exposeChatUtils () {
            /**
             * 暴露 setMessageValueById，目前用于微信语音转文字的回调（success、fail）
             * 这也显示出 EventBus 的局限性，但目前仅有这一处局限性，故不改为 Vuex 实现。
             */
            this.$eventBus.$on(SET_MESSAGE_VALUE_BY_ID, ({ id, path, value }) => {
                this.setMessageValueById(id, path, value)
            })
            // 消息评价
            this.$eventBus.$on(EVALUATE_MESSAGE, ({ id, value }) => {
                this.setMessageValueById(id, 'robot.evaluationValue', value)
            })
            // 撤回消息
            this.$eventBus.$on(WITHDRAW_MESSAGE, (id) => {
                // eslint-disable-next-line
                console.log(id)
            })
            // 删除消息
            this.$eventBus.$on(REMOVE_MESSAGE, (id) => {
                // eslint-disable-next-line
                console.log(id)
            })
        },
        destroyExposeChatUtils () {
            const events = [
                SET_MESSAGE_VALUE_BY_ID,
                WITHDRAW_MESSAGE,
                REMOVE_MESSAGE,
                EVALUATE_MESSAGE
            ]

            events.forEach(event => {
                this.$eventBus.$off(event)
            })
        }
    },
    beforeDestroy () {
        this.destroyExposeChatUtils()
    }
}
